import { Select, Form } from "antd";
import { useQuery } from "react-query";
import { getAllHubAppProfiles } from "../services/hubAppProfileService";

export const AppSelector = ({ value, onChange, placeholder }) => {
    const { data: appProfiles = [] } = useQuery(
        ["hub-app-profiles"],
        getAllHubAppProfiles,
        { staleTime: 5 * 60 * 1000 },
    );
    const appOptions = appProfiles.map((app) => ({
        value: app.id,
        label: app.label,
    }));

    return (
        <Select
            placeholder={placeholder || "App"}
            value={value}
            onChange={onChange}
            style={{ width: "100%" }}
            allowClear
        >
            {appOptions.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                    {option.label}
                </Select.Option>
            ))}
        </Select>
    );
};

export const AppSelectorInput = ({ required, placeholder, label, name }) => {
    const { data: appProfiles = [] } = useQuery(
        ["hub-app-profiles"],
        getAllHubAppProfiles,
        { staleTime: 5 * 60 * 1000 },
    );
    const appOptions = appProfiles.map((app) => ({
        value: app.id,
        label: app.label,
    }));

    return (
        <Form.Item
            name={name}
            label={label}
            rules={[{ required, message: "Please select an app!" }]}
        >
            <Select
                placeholder={placeholder || "App"}
                style={{ width: "100%" }}
                allowClear
            >
                {appOptions.map((option) => (
                    <Select.Option key={option.value} value={option.value}>
                        {option.label}
                    </Select.Option>
                ))}
            </Select>
        </Form.Item>
    );
};
